import { defineAsyncComponent } from 'vue'
import { trackRouter } from 'vue-gtag-next'
import { createRouter, createWebHistory, Router, RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: defineAsyncComponent(() => import('../views/HomeView.vue'))
  },
  {
    path: '/about',
    name: 'about',
    component: defineAsyncComponent(() => import('../views/AboutView.vue'))
  },
  {
    path: '/education',
    name: 'education',
    component: defineAsyncComponent(() => import('../views/EducationView.vue'))
  },
  {
    path: '/help',
    name: 'help',
    component: defineAsyncComponent(() => import('../views/HelpView.vue'))
  },
  {
    path: '/projects',
    name: 'projects',
    component: defineAsyncComponent(() => import('../views/ProjectsView.vue'))
  },
  {
    path: '/components-2',
    name: 'components-2',
    component: defineAsyncComponent(() => import('../views/projects/Components2View.vue'))
  },
  {
    path: '/components-1',
    name: 'components-1',
    component: defineAsyncComponent(() => import('../views/projects/Components1View.vue'))
  },
  {
    path: '/breachguard',
    name: 'breachguard',
    component: defineAsyncComponent(() => import('../views/projects/BreachGuardView.vue'))
  },
  {
    path: '/dealroom',
    name: 'dealroom',
    component: defineAsyncComponent(() => import('../views/projects/DealroomView.vue'))
  },
  {
    path: '/hackcheck',
    name: 'hackcheck',
    component: defineAsyncComponent(() => import('../views/projects/HackCheckView.vue'))
  },
  {
    path: '/holistance',
    name: 'holistance',
    component: defineAsyncComponent(() => import('../views/projects/HolistanceView.vue'))
  },
  {
    path: '/passwords',
    name: 'passwords',
    component: defineAsyncComponent(() => import('../views/projects/PasswordsView.vue'))
  },
  {
    path: '/petrapro',
    name: 'petrapro',
    component: defineAsyncComponent(() => import('../views/projects/PetraproView.vue'))
  },
  {
    path: '/spolujidlo',
    name: 'spolujidlo',
    component: defineAsyncComponent(() => import('../views/projects/SpolujidloView.vue'))
  },
  {
    path: '/skills',
    name: 'skills',
    component: defineAsyncComponent(() => import('../views/SkillsView.vue'))
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error',
    component: defineAsyncComponent(() => import('../views/ErrorView.vue'))
  }
]

const router: Router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

trackRouter(router)

export default router
